module.exports = __webpack_public_path__ + "img/rossmann.d8d7e758.png";